<template>
  <div>
    <!--卡片-->
    <div class="kpDiv">
      <img class="fw1" src="../../static/image/fw1.png" alt="" />
      <img class="fw2" src="../../static/image/fw2.png" alt="" />
      <img class="fw3" src="../../static/image/fw3.png" alt="" />
      <img class="fw4" src="../../static/image/fw4.png" alt="" />
      <!-- <img class="fw5"  src="../../static/image/fw5.png" alt="" /> -->

      <div  class="footer">
        <div class="ghDiv">
          <img class="ghImg" src="../../static/image/gh.png" alt="" :style="{width: isMobile ? '15px' : '25px'}" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index" :style="{fontSize: isMobile ? '8px' : '14px'}">京ICP备2026000484号-1</a>
        </div>
        <img src="../../static/image/footer.png" alt="" />
      </div>
    </div>
    <!-- <div class="container">
      <div class="row">
        <div class="col-sm-4">
          <h2>关于我</h2>
          <h5>我的照片:</h5>
          <div class="fakeimg">这边插入图像</div>
          <p>关于我的介绍..</p>
          <h3>链接</h3>
          <p>描述文本。</p>
          <ul class="nav nav-pills nav-stacked">
            <li class="active"><a href="#">链接 1</a></li>
            <li><a href="#">链接 2</a></li>
            <li><a href="#">链接 3</a></li>
          </ul>
          <hr class="hidden-sm hidden-md hidden-lg" />
        </div>
        <div class="col-sm-8">
          <h2>标题</h2>
          <h5>副标题</h5>
          <div class="fakeimg">图像</div>
          <p>一些文本..</p>
          <p>
            菜鸟教程，学的不仅是技术，更是梦想！！！菜鸟教程，学的不仅是技术，更是梦想！！！菜鸟教程，学的不仅是技术，更是梦想！！！
          </p>
          <br />
          <h2>标题</h2>
          <h5>副标题</h5>
          <div class="fakeimg">图像</div>
          <p>一些文本..</p>
          <p>
            菜鸟教程，学的不仅是技术，更是梦想！！！菜鸟教程，学的不仅是技术，更是梦想！！！菜鸟教程，学的不仅是技术，更是梦想！！！
          </p>
        </div>
      </div>
    </div> -->

    <!-- <div class="jumbotron text-center" style="margin-bottom: 0">
      <p>底部内容</p>
    </div> -->
  </div>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
};
</script>

<style scoped lang="scss">
.kpDiv {
  display: flex;
  flex-direction: column;
  img {
    width: 100%;    
    max-width: 100%;
    height: auto;  
  }
}
</style>
